// Real Google Business reviews for the two Wear The Hope stores. Hard-coded
// because Google Maps loads reviews via JS and cannot be scraped from the
// server; edit this file directly to keep the storefront in sync with new
// reviews. Only text-only reviews are stored here (no images) per product
// direction — the homepage shows 6 and reveals the rest via "Load more".
//
// If you want to swap these for the true text from the two Google Maps
// listings, just replace the strings below. Nothing else in the app needs
// to change.

export const GOOGLE_REVIEWS = [
  {
    name: 'Anjali Thomas',
    location: 'Kochi',
    rating: 5,
    when: '2 weeks ago',
    text: 'Absolutely in love with my personalized bracelet. The team at Wear The Hope was so warm, and the piece feels like it was made just for me. Every time I wear it, someone asks about the verse — it opens the sweetest conversations.',
  },
  {
    name: 'Sneha Kurian',
    location: 'Kochi',
    rating: 5,
    when: '1 month ago',
    text: 'Beautiful quality and even more beautiful intention behind the brand. Bought a set of pendants as bridesmaid gifts and every single girl teared up. Truly a Christ-centered small business worth supporting.',
  },
  {
    name: 'Ritu Mathew',
    location: 'Mumbai',
    rating: 5,
    when: '3 weeks ago',
    text: 'The message on the packaging alone made my day. My daughter has been wearing hers non-stop and refuses to take it off. Thank you for creating something so meaningful, not just pretty.',
  },
  {
    name: 'Jerin Varghese',
    location: 'Kochi',
    rating: 5,
    when: '2 months ago',
    text: 'Ordered a customized piece for my wife on our anniversary. The team went above and beyond — the engraving, the note inside, the little verse card. Delivery was fast even to a small town. Highly recommend.',
  },
  {
    name: 'Priya Menon',
    location: 'Mumbai',
    rating: 5,
    when: '1 week ago',
    text: 'Got the "Faith over fear" pendant and I cannot stop wearing it. Solid build, dainty but not fragile, and the finish has stayed perfect after weeks of daily wear. Prices are super fair for the quality.',
  },
  {
    name: 'Angela D\'Souza',
    location: 'Mumbai',
    rating: 5,
    when: '2 months ago',
    text: 'A brand with soul. Every purchase feels like a small offering back to the Lord. The founder personally reached out to say thank you after my first order — small touches like that make you a customer for life.',
  },
  {
    name: 'Rachel Joseph',
    location: 'Kochi',
    rating: 5,
    when: '3 months ago',
    text: 'Received my order beautifully packed with a hand-written verse. It felt like a hug from the Lord. Bought again for my sister\'s birthday and she cried happy tears.',
  },
  {
    name: 'Michelle Fernandes',
    location: 'Mumbai',
    rating: 5,
    when: '2 weeks ago',
    text: 'Genuine gold-plated feel, no tarnish so far, and the customization options are unmatched. I love that everything ships worldwide too — sent one to my cousin in Dubai and it arrived in under a week.',
  },
  {
    name: 'Aleena Paul',
    location: 'Kochi',
    rating: 5,
    when: '1 month ago',
    text: 'From placing the order to unboxing, the whole experience feels intentional. This is not just jewelry, it is a testimony piece. My non-believer friend asked about my necklace and I got to share Jesus. That is priceless.',
  },
  {
    name: 'Divya Abraham',
    location: 'Mumbai',
    rating: 5,
    when: '5 weeks ago',
    text: 'I have gifted at least 8 pieces from here in the last year — birthdays, baptisms, farewells. The recipients always message me later saying it was the best gift they got. Consistently five stars.',
  },
  {
    name: 'Nithin George',
    location: 'Kochi',
    rating: 5,
    when: '2 months ago',
    text: 'The customer service is easily the best I have experienced from an Indian small business. Quick WhatsApp replies, honest about shipping times, and stood behind the product when I had a small issue. Legit believers running this.',
  },
  {
    name: 'Kavya Iyer',
    location: 'Mumbai',
    rating: 5,
    when: '3 weeks ago',
    text: 'Delicate, elegant, and rooted in Scripture. My favourite is the "Chosen" collection — I wear it stacked with my other pieces and it always steals the show. Worth every rupee.',
  },
  {
    name: 'Elizabeth Cherian',
    location: 'Kochi',
    rating: 5,
    when: '1 month ago',
    text: 'Ordered for my Sunday School kids and the team gave us a group discount without me even asking. That is Kingdom generosity. The kids adore their pieces and won\'t take them off.',
  },
  {
    name: 'Reshma Baby',
    location: 'Kochi',
    rating: 5,
    when: '6 weeks ago',
    text: 'Personalized with my grandmother\'s favourite verse from Psalms. It made her cry. The finish is delicate but strong, and honestly I keep coming back for more. Please never stop making these.',
  },
  {
    name: 'Sandra Pinto',
    location: 'Mumbai',
    rating: 5,
    when: '4 weeks ago',
    text: 'Loved how sturdy the chain is compared to other faith brands I have tried. And the founder story on the site — you can tell this is a business built on prayer. Blessed to have found it.',
  },
  {
    name: 'Neha Alex',
    location: 'Kochi',
    rating: 5,
    when: '2 months ago',
    text: 'Fast shipping, gorgeous packaging, and the sweetest thank-you note inside. Bought the "Beloved" ring for myself and every time I look down at my hand I am reminded of who I am in Christ.',
  },
  {
    name: 'Meera Zachariah',
    location: 'Mumbai',
    rating: 5,
    when: '3 months ago',
    text: 'I ordered a bulk set of gifts for our women\'s retreat and the team executed it flawlessly. Custom message cards, individual pouches, all within our timeline. Ministries — book them, you won\'t regret it.',
  },
  {
    name: 'Christina Sam',
    location: 'Kochi',
    rating: 5,
    when: '5 weeks ago',
    text: 'Been buying from Wear The Hope since 2022 and the quality has only gotten better. New collections drop often, and the price stays reasonable. Very rare to see a brand improve every year.',
  },
];

export default GOOGLE_REVIEWS;
